import { ErrorResponse } from 'react-router-dom';
import { RequestMethods } from '../services/enum';
import { IUseHttpServiceProps } from '../services/type';
import {
  IUserSettingsDataSource,
  IUserSettingsInitialValues,
  IResponse,
} from '../types';

export default class UserSettingsService {
  private readonly baseUrl = 'auth/user/';

  constructor(
    private readonly executeService: <T>(
      args: IUseHttpServiceProps,
    ) => Promise<T | ErrorResponse | null>,
    private readonly parameters: string,
  ) {}

  async fetchData(): Promise<
    IResponse<IUserSettingsDataSource> | ErrorResponse | null
  > {
    return await this.executeService<IResponse<IUserSettingsDataSource>>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${this.parameters}`,
    });
  }

  async fetchItemById(
    id: number,
  ): Promise<IUserSettingsDataSource | ErrorResponse | null> {
    return await this.executeService<IUserSettingsDataSource>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async deleteItemById(id: number): Promise<unknown | ErrorResponse | null> {
    return await this.executeService<unknown>({
      method: RequestMethods.DELETE,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async exportData(): Promise<{ download_url: string } | ErrorResponse | null> {
    return await this.executeService<{ download_url: string }>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}export-excel/${this.parameters}`,
      contentType: 'multipart/form-data',
    });
  }

  async submitForm(
    values: IUserSettingsInitialValues,
    selectedItem?: IUserSettingsDataSource,
  ): Promise<IUserSettingsDataSource | ErrorResponse | null> {
    const method = selectedItem ? RequestMethods.PUT : RequestMethods.POST;
    const url = selectedItem
      ? `${this.baseUrl}${selectedItem.id}/`
      : this.baseUrl;

    return await this.executeService<IUserSettingsDataSource>({
      method,
      url,
      data: values,
    });
  }
}
